/** PT/EN skeleton strings from API — underscores only for letter/digit slots. */
export function pickWitcMediumSkeleton(
  q: { witcMediumSkeletonPt?: string | null; witcMediumSkeletonEn?: string | null },
  userLanguage: string | undefined
): string {
  const lang = userLanguage?.trim().toLowerCase() ?? 'en';
  const pt = (q.witcMediumSkeletonPt ?? '').trim();
  const en = (q.witcMediumSkeletonEn ?? '').trim();
  if (lang.startsWith('pt')) return pt || en;
  return en || pt;
}
